import { transformObjectKeys } from "@core/utility/common-utils"
import { RecursiveSnakeCaseType, transformFromSnakeCaseToCamelCase } from "@core/utility/string-utils"
import { Observable, of, take } from "rxjs"

export let getCardServerSessionIdLoad = (uiBody:GetCardServerSessionIdUIRequestBody): Observable<GetCardServerSessionIdAPIRequestBody>=>{


  let apiBody = new GetCardServerSessionIdAPIRequestBody({
    credit_card:{
      number:uiBody.cardNumber,
      month:uiBody.expiryDate.month,
      year:"20"+uiBody.expiryDate.year,
      verification_value:uiBody.securityCode
    }
  })
  return of(apiBody)
  .pipe(
    take(1),
  )
}

export let getCardServerSessionIdSuccess = (apiBody:GetCardServerSessionIdAPIResponseBody):GetCardServerSessionIdUIResponseBody=>{
  let uiBody = new GetCardServerSessionIdUIResponseBody(transformObjectKeys(
    apiBody,
    transformFromSnakeCaseToCamelCase
  ))
  return uiBody
}

export class GetCardServerSessionIdUIRequestBody {
  constructor(props:Partial<GetCardServerSessionIdUIRequestBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  cardNumber: string
  expiryDate: {
    month:  string,
    year: string
  }
  securityCode: string

}

export class GetCardServerSessionIdAPIRequestBody {
  constructor(props:Partial<GetCardServerSessionIdAPIRequestBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  credit_card:{
    number: string;
    first_name?: string;
    last_name?: string;
    month: string;
    year: string;
    verification_value: string;
  }
}

export class GetCardServerSessionIdUIResponseBody {
  constructor(props:Partial<GetCardServerSessionIdUIResponseBody>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
  id:string
}

export class GetCardServerSessionIdAPIResponseBody {
  constructor(props:Partial<RecursiveSnakeCaseType<GetCardServerSessionIdUIResponseBody>>={}){
    let origProps = Object.entries(props).filter(([key, val]) => {
      return !key.startsWith('prop');
    });
    Object.assign(this, { ...Object.fromEntries(origProps) });
  }
}

